export class TokenNotValidException extends Error {}

export class AuthenticationException extends Error {}

export class UserNotFoundException extends Error {}
